import React from 'react';
import {Form, Modal} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {useAddFactoryCompanyMutation, useEditFactoryCompanyMutation} from "../../redux/services/FactoryCompanyService";
import {sweetAlert} from "../../utils";
import {responseError} from "../../helpers/responseHandler";
import LoadingButtonWithForm from "../../components/LoadingButtonWithForm";
import PhoneInput from "react-phone-input-2";

const AddCompanyModal = ({isEdit, show, handleClose}) => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: {errors},
    } = useForm()

    const [addRequest, {isLoading: addLoading}] = useAddFactoryCompanyMutation()
    const [editRequest, {isLoading: editLoading}] = useEditFactoryCompanyMutation()

    const onSubmit = async (data) => {
        if (isEdit) {
            const newForm = {...data}
            await editRequest({id: isEdit?.id, newForm}).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        } else {
            const newForm = {...data}
            await addRequest(newForm).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        }
    }


    return (
        <>
            <Modal show={show} size="lg" onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">{isEdit ? 'Edit' : 'Add'} Factoring Company</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)} id='factory-status'>
                        <div className="row">
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Company Name:</Form.Label>
                                    <Controller
                                        name="company_name"
                                        control={control}
                                        defaultValue={isEdit?.company_name || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                placeholder="Enter company name"
                                                isInvalid={errors?.company_name}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Email:</Form.Label>
                                    <Controller
                                        name="email"
                                        control={control}
                                        defaultValue={isEdit?.email || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="email"
                                                placeholder="Enter email"
                                                isInvalid={errors?.email}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Phone:</Form.Label>
                                    <Controller
                                        name="phone"
                                        control={control}
                                        defaultValue={isEdit?.phone || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <div className={`${errors?.phone ? 'border border-danger' : ''}`}>
                                                <PhoneInput
                                                    {...field}
                                                    country={'us'} // Default country
                                                    inputProps={{
                                                        name: 'phone',
                                                        required: true,
                                                        autoFocus: true,
                                                    }}
                                                />
                                            </div>
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Address:</Form.Label>
                                    <Controller
                                        name="address"
                                        control={control}
                                        defaultValue={isEdit?.address || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                placeholder="Enter address"
                                                isInvalid={errors?.address}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Description:</Form.Label>
                                    <Controller
                                        name="description"
                                        control={control}
                                        defaultValue={isEdit?.description || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                as="textarea"
                                                rows={3}
                                                placeholder="Enter description"
                                                isInvalid={errors?.description}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                        </div>

                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <LoadingButtonWithForm
                        isLoading={editLoading ? editLoading : addLoading}
                        name="Save"
                        form="factory-status"
                    />
                </Modal.Footer>

            </Modal>
        </>
    );
};

export default AddCompanyModal;